import React, {useContext, useEffect, useState, useRef} from 'react';
import Styles from '../styles/components/OrderOfService.module.css';
import {load_fetch, isUserInRole } from "../pr_utils";
import { AuthContext } from "../AuthContext";
import {useNavigate} from "react-router-dom";


const isEnabled = (value) => String(value) === "1";
const isSongElement = (type) => type === 'song' || type === 'hymn';

const OrderOfService = ({
            serviceElements,
            moveElement,
            service,
            addElement,
            removeElement,
            insertNewSermon,
            selectedSermon,
            allSongs,
            allSermons,
            editSong,
            setSelectedSermon}) => {
    const { authStatus } = useContext(AuthContext);
    const navigate = useNavigate();
    const [showAddForm, setShowAddForm] = useState(false);
    const [newType, setNewType] = useState('');
    const [newText, setNewText] = useState('');
    //const [allSongs, setAllSongs] = useState([]);
    const [songSearch, setSongSearch] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const hasElements = serviceElements && serviceElements.length > 0;
    const sortedElements = [...(serviceElements || [])].sort(
        (a, b) => a.position - b.position
    );
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const [selectedSong, setSelectedSong] = useState(null);

    const [sermonSearch, setSermonSearch] = useState('');
    const [sermonSuggestions, setSermonSuggestions] = useState([]);
    const [sermonHighlightedIndex, setSermonHighlightedIndex] = useState(-1);
    //const [selectedSermon, setSelectedSermon] = useState(null);
    //const [allSermons, setAllSermons] = useState([]);

    const [showNewSermonForm, setShowNewSermonForm] = useState(false);
    const [newSermonTitle, setNewSermonTitle] = useState('');
    const [newSermonBibleText, setNewSermonBibleText] = useState('');
    const [newSermonNotes, setNewSermonNotes] = useState('');

    const elementTypeSelector = useRef(null);
    const songSearchBox = useRef(null);
    const sermonSearchBox = useRef(null);
    const submitNewElementButton = useRef(null);
    const addServiceElementButton = useRef(null);

    // Use Effects
    useEffect(() => {
        //getAllSongs();
        //getAllSermons();
    }, []);
    useEffect(() => {
        if(showAddForm) {
            elementTypeSelector.current.focus();
        }
    }, [showAddForm]);
    useEffect(() => {
        console.log("New Type: " + newType);
        if(newType === 'hymn' || newType === 'song') {
            songSearchBox.current.focus();
            return;
        }

        if(newType === 'sermon') {
            sermonSearchBox.current.focus();
        }

    }, [newType]);


    // Ajax Functions

    const handleNewSermonSubmit = () => {
        const newSermon = {
            title:newSermonTitle,
            bible_text: newSermonBibleText,
            description: newSermonNotes,
            sermon_date: service['service_date']
        }

        insertNewSermon(newSermon);

        setShowNewSermonForm(false);
        setNewSermonTitle('');
        setNewSermonBibleText('');
        setNewSermonNotes('');
    }



    // Other Functions
    const handleSearchChange = (e) => {
        const query = e.target.value; //.toLowerCase();
        setSongSearch(query);

        const filtered = allSongs.filter(song =>
            song.title.toLowerCase().includes(query.toLowerCase()) ||
            (song.hymn_number && song.hymn_number.toString().includes(query.toLowerCase())) ||
            (song.songwriter && song.songwriter.toLowerCase().includes(query.toLowerCase()))
        );

        //setSuggestions(filtered.slice(0, 25)); // top 5 matches
        setSuggestions(filtered);
    };
    const handleSongSelect = (song) => {
        console.log(song);

        setSelectedSong(song);
        setSongSearch(song.title); // or just hide the input
        setSuggestions([]);
        setHighlightedIndex(-1);

        submitNewElementButton.current.focus();
    }
    const handleKeyDown = (e) => {
        if (!suggestions.length) return;

        if (e.key === 'ArrowDown') {
            setHighlightedIndex((prev) => (prev + 1) % suggestions.length);
        } else if (e.key === 'ArrowUp') {
            setHighlightedIndex((prev) => (prev - 1 + suggestions.length) % suggestions.length);
        } else if (e.key === 'Enter') {
            e.preventDefault(); // prevent form submit
            if (highlightedIndex >= 0 && highlightedIndex < suggestions.length) {
                handleSongSelect(suggestions[highlightedIndex]);
            }
        }
    };

    const handleSermonSearchChange = (e) => {
        setSermonSearch(e.target.value);
        const query = e.target.value.toLowerCase();

        const filtered = allSermons.filter(sermon =>
            (sermon.title && sermon.title.toLowerCase().includes(query)) ||
            (sermon.bible_text && sermon.bible_text.toLowerCase().includes(query)) ||
            (sermon.sermon_date && sermon.sermon_date.toLowerCase().includes(query))
        );

        setSermonSuggestions(filtered);//.slice(0, 5));
        setSermonHighlightedIndex(0);
    };
    const handleSermonKeyDown = (e) => {
        if (!sermonSuggestions.length) return;

        if (e.key === 'ArrowDown') {
            setSermonHighlightedIndex((prev) => (prev + 1) % sermonSuggestions.length);
        } else if (e.key === 'ArrowUp') {
            setSermonHighlightedIndex((prev) => (prev - 1 + sermonSuggestions.length) % sermonSuggestions.length);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (sermonHighlightedIndex >= 0 && sermonHighlightedIndex < sermonSuggestions.length) {
                handleSermonSelect(sermonSuggestions[sermonHighlightedIndex]);
            }
        }
    };

    const handleSermonSelect = (sermon) => {
        console.log(sermon);

        setSelectedSermon(sermon);
        setSermonSearch(sermon.title);
        setSermonSuggestions([]);
        setSermonHighlightedIndex(-1);

        submitNewElementButton.current.focus();
    };

    const viewChords = (song_id) => {
        navigate("/song_viewer?song_id=" + song_id + "&service_id=" + service.service_id);
    }
    const addChords = (song_id) => {
        navigate("/chords_editor?song_id=" + song_id + "&service_id=" + service.service_id);
    }






    return (
        <div className={Styles.container}>
            <h2 className={Styles.heading}>Order of Service</h2>

            {!hasElements && (
                <p className={Styles.placeholder}>
                    No service elements have been added yet.
                </p>
            )}

            {hasElements && (
                <ul className={Styles.elementList}>
                    {sortedElements.map((el, index) => {
                        const isBlacklisted = isSongElement(el.type) && isEnabled(el.is_blacklisted);

                        return (
                        <li
                            key={el.service_element_id}
                            className={`${Styles.elementItem} ${isBlacklisted ? Styles.blacklistedElement : ''}`}
                        >

                            <div className={isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR']) ? Styles.reorderButtons : Styles.hidden}>
                                <button
                                    onClick={() => moveElement(el.service_element_id, 'up')}
                                    disabled={index === 0}
                                    className={Styles.reorderButton}
                                >
                                    ⬆️
                                </button>
                                <button
                                    onClick={() => moveElement(el.service_element_id, 'down')}
                                    disabled={index === sortedElements.length - 1}
                                    className={Styles.reorderButton}
                                >
                                    ⬇️
                                </button>
                                <button
                                    onClick={() => removeElement(el.service_element_id)}
                                    className={Styles.removeButton}
                                >
                                    ✖️
                                </button>
                            </div>

                            <span className={Styles.type}>{el.type}</span>

                            {/* Title (song/hymn/sermon) */}
                            {el.title && (
                                <span className={Styles.title}> – {el.title}</span>
                            )}

                            {/* Hymn number (if present) */}
                            {el.hymn_number && (
                                <span className={Styles.hymnNumber}> (#{el.hymn_number})</span>
                            )}

                            {/* Hymn number (if present) */}
                            {(el.type === 'song' || el.type === 'hymn') && !el.has_slideshow && (
                                <span className={Styles.noSlideshowWarning}> NO SLIDESHOW</span>
                            )}

                            {isBlacklisted && (
                                <div className={Styles.blacklistWarning}>
                                    <span className={Styles.blacklistBadge}>BLACKLISTED</span>
                                    <span className={Styles.blacklistMessage}>
                                        {el.blacklist_reason || 'This song has been marked not to use.'}
                                    </span>
                                </div>
                            )}

                            {/* Has Chords or No for Songs/Hymns */}
                            {(el.type === 'song' || el.type === 'hymn') && (
                                <>
                                    <span className={Styles.noSlideshowWarning}> {el.hasChords ?
                                        <button
                                            className={Styles.addButton}
                                            onClick={() => viewChords(el.ref_id)}
                                        >View Chords</button> :
                                        isUserInRole(authStatus, ['SERVICE_EDITOR', 'ADMIN']) ? (<button
                                            className={Styles.addChordsButton}
                                            onClick={() => addChords(el.ref_id)}
                                        >Add Chords</button>) : ''
                                    }</span>
                                    {isUserInRole(authStatus, ['SERVICE_EDITOR', 'ADMIN']) && (
                                        <button
                                            className={Styles.addButton}
                                            onClick={() => editSong(el.ref_id)}
                                        >
                                            Edit Song
                                        </button>
                                    )}
                                </>
                            )}

                            {/* Bible text (sermon-specific) */}
                            {el.bible_text && (
                                <span className={Styles.bibleText}> – {el.bible_text}</span>
                            )}

                            {/* Text (custom/plain element) */}
                            {el.text && (
                                <span className={Styles.text}> – {el.text}</span>
                            )}

                            {/* Optional: Show ref_id for debugging */}
                            {/* {el.ref_id && (
                            <span className={Styles.ref}> [ref ID: {el.ref_id}]</span>
                        )} */}
                        </li>
                    )})}
                </ul>
            )}

            <button
                ref={addServiceElementButton}
                className={isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR']) ? Styles.addButton : Styles.hidden}
                onClick={() => setShowAddForm(!showAddForm)}>
                {showAddForm ? 'Cancel' : 'Add Service Element'}
            </button>

            {showAddForm && (
                <div className={Styles.addForm}>
                    <label>
                        Type:
                        <select
                            ref={elementTypeSelector}
                            value={newType}
                            onChange={(e) => setNewType(e.target.value)}
                        >
                            <option value="">-- Select Type --</option>
                            <option value="song">Song</option>
                            <option value="hymn">Hymn</option>
                            <option value="sermon">Sermon</option>
                            <option value="scripture_reading">Scripture Reading</option>
                            <option value="prayer">Prayer</option>
                            <option value="announcements">Announcements</option>
                            <option value="communion">Communion</option>
                            <option value="custom">Custom</option>
                        </select>
                    </label>

                    {(newType === 'scripture_reading' || newType === 'custom') && (
                        <label>
                            Text:
                            <textarea
                                value={newText}
                                onChange={(e) => setNewText(e.target.value)}
                                placeholder="Enter text..."
                            />
                        </label>
                    )}

                    {(newType === 'song' || newType === 'hymn') && (
                        <div className={Styles.searchWrapper}>
                            <label>
                                Search {newType === 'hymn' ? 'Hymn' : 'Song'}:
                                {selectedSong ? (
                                    <div className={Styles.selectedItem}>
                                        <button
                                            type="button"
                                            className={Styles.clearButton}
                                            onClick={() => {
                                                setSelectedSong(null);
                                                setSongSearch('');
                                                setSuggestions([]);
                                                setHighlightedIndex(-1);
                                            }}
                                        >
                                            ✕ Clear
                                        </button>
                                        <div>
                                            {selectedSong.title}
                                            {selectedSong.hymn_number && ` (Hymn #${selectedSong.hymn_number})`}
                                            {selectedSong.songwriter && ` – ${selectedSong.songwriter}`}
                                            {isEnabled(selectedSong.is_blacklisted) && (
                                                <div className={Styles.selectedBlacklistWarning}>
                                                    <span className={Styles.blacklistBadge}>BLACKLISTED</span>
                                                    <span>{selectedSong.blacklist_reason || 'Marked not to use.'}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <input
                                        ref={songSearchBox}
                                        type="text"
                                        className={Styles.searchInput}
                                        placeholder="Search..."
                                        value={songSearch}
                                        onChange={handleSearchChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                )}
                            </label>

                            {suggestions.length > 0 && (
                                <ul className={Styles.suggestionList}>
                                    {suggestions.map((song, index) => (
                                        <li
                                            key={song.song_id}
                                            className={`${Styles.suggestionItem} ${
                                                index === highlightedIndex ? Styles.suggestionItemActive : ''
                                            } ${isEnabled(song.is_blacklisted) ? Styles.blacklistedSuggestion : ''}`}
                                            onMouseEnter={() => setHighlightedIndex(index)}
                                            onClick={() => handleSongSelect(song)}
                                        >
                                            {song.title}
                                            {song.hymn_number && ` (Hymn #${song.hymn_number})`}
                                            {song.songwriter && ` (${song.songwriter})`}
                                            {isEnabled(song.is_blacklisted) && (
                                                <span className={Styles.suggestionBlacklistBadge}> BLACKLISTED</span>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}

                    {newType === 'sermon' && (
                        <div className={Styles.searchWrapper}>
                            <label>
                                Search Sermon:
                                {selectedSermon ? (
                                    <div className={Styles.selectedItem}>
                                        <button
                                            type="button"
                                            className={Styles.clearButton}
                                            onClick={() => {
                                                setSelectedSermon(null);
                                                setSermonSearch('');
                                                setSermonSuggestions([]);
                                                setSermonHighlightedIndex(-1);
                                            }}
                                        >
                                            ✕ Clear
                                        </button>
                                        {selectedSermon.title}
                                        {selectedSermon.bible_text && ` – ${selectedSermon.bible_text}`}
                                    </div>
                                ) : (
                                    <>
                                        <input
                                            ref={sermonSearchBox}
                                            type="text"
                                            className={Styles.searchInput}
                                            placeholder="Search by title, scripture, or date"
                                            value={sermonSearch}
                                            onChange={handleSermonSearchChange}
                                            onKeyDown={handleSermonKeyDown}
                                        />

                                        {sermonSuggestions.length > 0 && (
                                            <ul className={Styles.suggestionList}>
                                                {sermonSuggestions.map((sermon, index) => (
                                                    <li
                                                        key={sermon.sermon_id}
                                                        className={`${Styles.suggestionItem} ${
                                                            index === sermonHighlightedIndex ? Styles.suggestionItemActive : ''
                                                        }`}
                                                        onMouseEnter={() => setSermonHighlightedIndex(index)}
                                                        onClick={(event) => {
                                                            event.preventDefault();
                                                            handleSermonSelect(sermon);
                                                        }}
                                                    >
                                                        {sermon.title}
                                                        {sermon.bible_text && ` – ${sermon.bible_text}`}
                                                        {sermon.sermon_date && ` (${sermon.sermon_date})`}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                        <button
                                            type="button"
                                            className={Styles.newSermonButton}
                                            onClick={() => setShowNewSermonForm(!showNewSermonForm)}
                                        >
                                            + New Sermon
                                        </button>

                                        {showNewSermonForm && (
                                            <div className={Styles.newSermonForm}>
                                                <label>
                                                    Title:
                                                    <input
                                                        type="text"
                                                        value={newSermonTitle}
                                                        onChange={(e) => setNewSermonTitle(e.target.value)}
                                                    />
                                                </label>
                                                <label>
                                                    Scripture:
                                                    <input
                                                        type="text"
                                                        value={newSermonBibleText}
                                                        onChange={(e) => setNewSermonBibleText(e.target.value)}
                                                    />
                                                </label>
                                                <label>
                                                    Notes:
                                                    <textarea
                                                        value={newSermonNotes}
                                                        onChange={(e) => setNewSermonNotes(e.target.value)}
                                                    />
                                                </label>
                                                <button
                                                    type="button"
                                                    className={Styles.submitButton}
                                                    onClick={handleNewSermonSubmit}
                                                >
                                                    Save Sermon
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </label>
                        </div>
                    )}



                    <button
                        ref={submitNewElementButton}
                        className={Styles.submitButton} onClick={() => {
                        console.log('Submit element:', { newType, newText });

                        const newElement = {
                            type: newType,
                            ref_id: selectedSong?.song_id || selectedSermon?.sermon_id || null,
                            text: newText || null,
                        };

                        addElement(newElement);

                        setSelectedSong(null);
                        setSelectedSermon(null);
                        setSongSearch('');
                        setSermonSearch('');
                        setShowAddForm(false);
                        setSuggestions([]);
                        setSermonSuggestions([]);
                        setNewType('');
                        setNewText('');

                        addServiceElementButton.current.focus();
                    }}>
                        Submit New Element
                    </button>
                </div>
            )}
        </div>
    );

};

export default OrderOfService;
